var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMfIcon = function SvgMfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C79F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 9.44c-.78-.201-1.866-.5-2.735-.5C7.976 8.94 4.5 11.61 4.5 14.9c0 1.89 1.148 3.575 2.938 4.667l-.485 1.6a.6.6 0 0 0 .574.774h1.764a.6.6 0 0 0 .36-.12l1.395-1.047h2.437l1.395 1.047a.6.6 0 0 0 .36.12h1.764a.6.6 0 0 0 .574-.774l-.485-1.6c1.067-.65 1.905-1.511 2.409-2.501M15 9.44l4.5-1.5-.084 3.63 2.084.87v3.5l-1.926 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C79F7",
    stroke: "#2C79F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 13.94a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C79F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.5 10.94s0 2.4 2 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C79F7",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.3 8.694c.13-.372.2-.772.2-1.188 0-1.97-1.567-3.565-3.5-3.565S6.5 5.537 6.5 7.506c0 .941.358 1.798.944 2.435"
  })));
};
export { SvgMfIcon as ReactComponent };
export default __webpack_public_path__ + "5f386602b64ee6aaca9a9a5322c46a4d.svg";